import React, { useState } from 'react'
import bg from '../../images/aspirationBanner.webp'
import { useDispatch, useSelector } from 'react-redux';
import ToggleMenu from '../common/ToggleMenu'
import ContactModal from './ContactModal';
import {setToggleTrue} from '../../redux/slice/changeState'
import { useMediaQuery } from 'react-responsive';

const MobileBanner = () => {
  const isTablet = useMediaQuery({ query: '(min-width: 769px) and (max-width: 991px)' });
  const dispatch = useDispatch()
  const toggle = useSelector((state) => state.toggle);

  return (
    <>
      <div className='text-center banner' style={{ backgroundImage: `url(${bg})` }}>
        <ToggleMenu />

        <div className='banner-title'>
          <h3>Welcome to <span className='ira'>VeeraSynergies</span>Pvt. Ltd</h3>
        </div>
        <div className='banner-discption'>
          <h1 className='text-uppercase' >Your Partner in Infrastructure, Renewable Energy, Warehousing, and IT Consulting</h1>
         
          <div className='mt-7' style={{padding: isTablet ? '0% 14%' : ''}}>
            {isTablet ? 
            <>
            
              <span className='text-white'>At VeeraSynergies, we believe in empowering businesses and communities with innovative, sustainable, and efficient solutions. Our expertise spans a wide range of industries, ensuring excellence and commitment in every project we undertake. From building world-class infrastructure to pioneering green energy initiatives, we are dedicated to delivering results that make a difference.</span><br/>
         
            </>
            :
            <>
              <span>At VeeraSynergies, we believe in empowering businesses and communities with innovative, sustainable, and efficient solutions. Our expertise spans a wide range of industries, ensuring excellence and commitment in every project we undertake. From building world-class infrastructure to pioneering green energy initiatives, we are dedicated to delivering results that make a difference.</span><br />
         
            </>
          }
            
            
          </div>
        </div>

      </div>
      {
                toggle.hastoggle && <ContactModal />
            }
    </>
  )
}

export default MobileBanner
